import { render, staticRenderFns } from "./progressbar.vue?vue&type=template&id=70fbf49d&"
import script from "./progressbar.vue?vue&type=script&lang=ts&"
export * from "./progressbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70fbf49d')) {
      api.createRecord('70fbf49d', component.options)
    } else {
      api.reload('70fbf49d', component.options)
    }
    module.hot.accept("./progressbar.vue?vue&type=template&id=70fbf49d&", function () {
      api.rerender('70fbf49d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/progressbar/progressbar.vue"
export default component.exports